import React from "react";
import TextFormField from "./TextFormField";

export default function DefaultFormField(props) {
    return <TextFormField {...props} />;
}